import React from "react";
import "./AboutStuttering.css";
import placeholder from "./assets/image.png";
import pfp from "../assets/pfp.jpg";
import Footer from "../Footer";
import QuestionsPreview from "../QuestionsPreview";
import LatestInfo from "../LatestInfo";

const sampleFaq = [
  {
    title: 'Mi a dadogás?',
    answer: 'A dadogás egy beszédzavar, amelyre jellemző a szavak, szótagok vagy hangok ismétlése, megnyújtása, illetve a beszéd elakadása. Nem egyszerűen idegesség vagy rossz szokás – neurológiai alapja van, és az érintett nem tud akaratlagosan megállítani.'
  },
  {
    title: 'Miért dadognak az emberek?',
    answer: 'A dadogás pontos oka még nem teljesen ismert, de bizonyított, hogy neurológiai tényezők játszanak benne szerepet: a dadogó emberek más agyi idegpályákat használnak a beszédhez. Genetikai hajlam is szerepet játszik – az érintettek kb. 65%-ánál van más érintett a családban.'
  },
  {
    title: 'Elmúlik a dadogás?',
    answer: 'A gyermekek egy részénél (kb. 80%) a dadogás természetes módon elmúlik óvodás- vagy kisiskoláskorban. Ha azonban kb. 7 éves kor után is fennáll, már nem múlik el magától – de tünetmentessé válhat megfelelő terápiával és önsegítő munkával.'
  },
  {
    title: 'Igaz-e, hogy a dadogók azért dadognak, mert idegesek?',
    answer: 'Ez az egyik legelterjedtebb tévhit. A valóság épp fordítva áll: a dadogók azért lehetnek idegesek, mert dadognak – és nem azért dadognak, mert idegesek. A csak nyugodj meg típusú tanácsok általában nem segítenek.'
  },
  {
    title: 'Mit tegyek, ha valaki dadogva beszél velem?',
    answer: 'A legfontosabb: légy türelmes, és várj, amíg az illető befejezi a mondatát. Ne fejezd be helyette a szavait. Tartsd a szemkontaktust természetes módon, és reagálj a mondanivalóra – nem a dadogásra.'
  },
  {
    title: 'Lehet-e valaki sikeres dadogással?',
    answer: 'Természetesen. Számos ismert személyiség dadogással élt vagy él: Winston Churchill, Joe Biden, Ed Sheeran, Samuel L. Jackson. A dadogás nem akadályozza meg az érintetteket abban, hogy bármilyen területen kiemelkedőt alkossanak.'
  },
  {
    title: 'Mennyire elterjedt a dadogás?',
    answer: 'A világ népességének körülbelül 1%-a dadogással él – ez globálisan mintegy 80 millió embert jelent. Magyarországon ez kb. 100 000 érintett személyt jelent. A dadogás háromszor-négyszer gyakoribb férfiaknál, mint nőknél.'
  },
];

const AboutStuttering = () => {
  return (
    <main className="aboutstuttering">

      <div className="as-hero-wrap">
        <div
          className="as-hero-image"
          style={{ backgroundImage: `url(${placeholder})` }}
        ></div>
      </div>

      <section className="as-content-wrapper">
        <div className="article-grid">
          <article className="article-left">
            <h1>A dadogásról</h1>

            <p>A dadogás pontos okai még nem ismertek, több megközelítés létezik. A neurológiai érintettség bizonyított, vagyis hogy a dadogók más agyi idegpályákat használnak a beszédben, mint a folyamatos beszélők. Ez az állapot egy bizonyos kor után (kb. 7 éves kor) a legjobb tudásunk szerint már nem múlik el, de tünetmentessé válhat valaki (például más idegpályák kiépítésével-használatával). A kutatások szerint genetikai faktor is szerepet játszik: az érintettek 65%-nál találtak más érintettet is a családban (ez a szám magasabb is lehet, mivel sokan, főleg a régebbi generációk esetében, titkolják, szégyellik a dadogásukat). Poligénes ikervizsgálatok is rendelkezésre állnak, az együttható 90% feletti.</p>

            <p>Emellett pszichoszociális tényezőktől is nagyban függ a beszéd, illetve a dadogás aktuális minősége: számít a beszédhelyzet, a beszédtéma, a fáradtsági szint, a beszélgetőpartner személye. Érdekes, hogy nemcsak a rossz hangulat van hatással a dadogásra, hanem a kitörő jó hangulat, az izgatottság is.</p>

            <p>A fentiekből is látszik, hogy a dadogó emberek valószínűleg nem azért dadognak, mert gyerekkorukban egy konkrét trauma érte őket, amit még nem tudtak feldolgozni – az ilyesmi legfeljebb triggerként, súlyosbító tényezőként szolgálhat. Legtöbbször azért tűnhetnek idegesebbnek, mert sok negatív tapasztalatuk volt a beszéddel kapcsolatban, és fizikailag is nehezebben megy nekik.</p>

            <p>Dadogóként tehát azért lehetünk idegesek, mert dadogunk, és nem azért dadogunk, mert idegesek vagyunk. Ez egy nagyon fontos különbség! Ezért a legtöbb dadogónak egyáltalán nem segít, ha azt mondják neki: nyugi, csak lassan, nem kell izgulni. Sőt, ez gyakran még jobban frusztrálja az érintetteket, mert a dadogásukra helyeződik a fókusz. 
            Ami biztosan segít: türelmes, empatikus hozzáállás; ne a dadogáson legyen a fókusz, hanem azon, amit a dadogó személy mond (üzenet). És nem kell helyette kimondani-befejezni a szavakat, mondatokat, csak kivárni, amíg ő maga elmondja. (Ez nyilván igényel némi alkalmazkodást a beszélgetőpartnertől – a dadogók türelemre, elfogadásra tanítanak).</p>
          </article>

          <aside className="article-right">
            <div className="publish-date">2025. NOVEMBER 16.</div>

            <div className="author-frame">
              <img src={pfp} alt="BeszÉLJ Egyesület" className="author-photo" />
              <div className="author-details">
                <span className="author-name">BeszÉLJ Egyesület</span>
                <span className="author-role">Szerző</span>
              </div>
            </div>
          </aside>
        </div>
      </section>
      <LatestInfo />
      <QuestionsPreview
        questions={sampleFaq}
        onSeeAll={() => (window.location.href = "/faq")}
      />
      <Footer />
    </main>
  );
};

export default AboutStuttering;